import { Box } from '@primer/react';
import clsx from 'clsx';
import { forwardRef, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks/useAppDispatch';
import styles from './Header2.module.css';
import logo from './logo.png';
import { Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { appConst } from '../AppConst';
import { logout } from '../faetures/auth/authSlice';
import { RootState } from '../store/store';
const Header2 = forwardRef<HTMLDivElement>((props, ref) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const { user } = useSelector((x: RootState) => x.auth);
    const handleLogout = () => {
        dispatch(logout());
        navigate('../../signout-oidc');
    };
    const character_name = useMemo(() => {
        const texts = user?.full_name.split(' ') ?? [];
        return texts[texts.length - 1].split('')[0];
    }, [user?.full_name]);
    const [anchorMenuAccountEl, setAnchorMenuAccountEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorMenuAccountEl);
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorMenuAccountEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorMenuAccountEl(null);
    };
    return (
        <section ref={ref} id={clsx(styles.header)} style={{ height: `${appConst.headerHeight}px` }}>
            <div className={clsx(styles.left)}>
                <p>{appConst.authName}</p>
                <p>{appConst.authDescription}</p>
            </div>
            <div className={clsx(styles.mid)}>
                <a href="/" className={clsx(styles.logo)}>
                    <img
                        src="https://main.hau.edu.vn/images/logo.png"
                        alt="Logo"
                    />
                </a>
                <div className={clsx(styles.nameProduct)}>
                    <p>{appConst.schoolName}</p>
                    <p>{appConst.appicationName}</p>
                </div>
            </div>
            <div className={clsx(styles.right)}>
                {/* <div className={clsx(styles.searchForm)}></div> */}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ m: 1 }}></Box>
                </Box>
                <Box>
                    <Tooltip title="Account settings">
                        <IconButton
                            onClick={handleOpenMenu}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? 'account-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}>
                            <img
                                alt="avatar"
                                src={`../../../../images/${character_name}.png`}
                                width={48}
                                height={48}
                                style={{
                                    borderRadius: '50%',
                                    border: '2px solid #fff'
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorMenuAccountEl}
                        id="account-menu"
                        open={open}
                        onClose={handleCloseMenu}
                        onClick={handleCloseMenu}
                        slotProps={{
                            paper: {
                                elevation: 0,
                                sx: {
                                    overflow: 'visible',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                    mt: 1.5,
                                    '& .MuiAvatar-root': {
                                        width: 32,
                                        height: 32,
                                        ml: -0.5,
                                        mr: 1
                                    },
                                    '&::before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0
                                    }
                                }
                            }
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
                        <MenuItem onClick={handleCloseMenu}>
                            <ListItemIcon>
                                <AccountBoxIcon />
                            </ListItemIcon>
                            Thông tin tài khoản
                        </MenuItem>
                        <MenuItem onClick={handleCloseMenu}>
                            <ListItemIcon>
                                <VpnKeyOutlinedIcon />
                            </ListItemIcon>
                            Đổi mật khẩu
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={handleLogout}>
                            <ListItemIcon>
                                <LogoutIcon />
                            </ListItemIcon>
                            Đăng xuất
                        </MenuItem>
                    </Menu>
                </Box>
            </div>
        </section>
    );
});

export default Header2;
